import { isDefined, fetchData } from '@automator/utilities';

/**
 * Re-runs items on demand
 */
class ReRunItem {
    constructor() {
        // Listen clicks to the re-run buttons
        this.listenSubmissions();
    }

    /**
     * Listens clicks to the buttons and triggers the request
     */
    listenSubmissions() {
        this.$reRunButtons.forEach( ( $button ) => {
            $button.addEventListener( 'click', () => {
                // Perform request
                this.doRequest( $button );
            } );
        } );
    }

    /**
     * Performs the request that re-runs the item
     * 
     * @param {Node} $button The clicked button
     */
    doRequest( $button ) {
        // Check if the button is defined
        if ( ! isDefined( $button ) ) {
            return;
        }

        // Check if the required data is defined
        if ( ! isDefined( $button.dataset.item ) ) {
            console.error( `Re-run item: The button doesn't contain the required dataset. Define a valid "data-item"` );
            return;
        }
        
        // First, show a loading animation
        $button.loading = true;

        // Remove the alert attached to the button, if there is one.
        this.maybeRemoveMessage( $button );

        // Start request
        fetchData( {
            url: `${ UncannyAutomatorBackend.rest.url }/resend_api_request`,
            data: {
                item_log_id: parseInt( $button.dataset.item )
            },
            isWordPressREST: true,
            onSuccess: ( response ) => {
                // Show message
                this.showMessage( $button, ( response.success ? 'success' : 'error' ), response.message );

                // Remove loading animation
                $button.loading = false;
            },
            onFail: ( errorCode, response ) => {
                // Otherwise, show error
                this.showMessage( $button, 'error', UncannyAutomatorBackend.i18n.error.request.generic.title );
            }
        } );
    }

    /**
     * Shows an alert below the button
     * 
     * @param {Node} $button The button that triggered the request
     * @param {String} type The alert type. `[ 'success', 'error' ]`
     * @param {String} message The message to be displayed
     */
    showMessage( $button, type, message ) {
        // Check if the message is defined
        if ( ! isDefined( message ) ) {
            return;
        }

        // Check if the button is defined
        if ( ! isDefined( $button ) ) {
            return;
        }

        // Get the wrapper
        const $wrapper = $button.closest( '.uap-logs-details-re-run-action-wrapper' );

        // Check if the wrapper exists
        if ( ! isDefined( $wrapper ) ) {
            console.error( `Re-run item: The wrapper is missing. Add your button inside an element with the class .uap-logs-details-re-run-action-wrapper` );
            return;
        }

        // Stop loading animation of the button
        $button.loading = false;

        // Check if it's not defined, and create one
        if ( ! isDefined( $wrapper.querySelector( 'uo-alert' ) ) ) {
            $button.insertAdjacentHTML( 'afterEnd', `
                <uo-alert
                    type="${ type }"
                    size="small"

                    class="uap-spacing-top"
                ></uo-alert>
            ` );
        }

        // Get the error alert
        const $errorAlert = $wrapper.querySelector( 'uo-alert' ); 

        // Set message
        $errorAlert.innerText = message;
    }

    /**
     * Removes the alert attached to a button, if there is one
     * 
     * @param {Node} $button The button that triggered the request
     */
    maybeRemoveMessage( $button ) {
        // Get the wrapper
        const $wrapper = $button.closest( '.uap-logs-details-re-run-action-wrapper' );

        // Check if the alert exists
        if ( $wrapper.querySelector( 'uo-alert' ) ) {
            const $alert = $wrapper.querySelector( 'uo-alert' );

            // Remove it
            $alert.parentNode.removeChild( $alert );
        }
    }

    /**
     * Returns the buttons that will trigger the request
     * 
     * @return {NodeList} The buttons
     */
    get $reRunButtons() {
        return document.querySelectorAll( 'uo-button.uap-logs-details-re-run-action' );
    }
}

export default ReRunItem;